import React from 'react'

import { useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'

import ShareableContentLibraryTrackedRoute from '@components/ShareableContentLibrary/TrackedRoute'
import { CardContainer, CardIcon } from '@components/UI/Card/Card'
import { MediaThumbnail } from '@components/UI/Media'
import { AspectRatios, EventTrackingNames, MediaTypes, PageRoutes } from '@enums'
import { IApplicationState } from '@store'
import { selectIsVideoMediaType, selectThumbnailMediaUrl } from '@store/mediaObjects'
import { Container } from '@tribegroup'

interface IMediaObjectCardProps {
  mediaObjectCardId: number
}

interface IParams {
  token: string
}

const ShareableContentLibraryCard: React.FC<IMediaObjectCardProps> = ({ mediaObjectCardId }) => {
  const { token } = useParams<IParams>()
  const isVideoMediaType = useSelector((state: IApplicationState) =>
    selectIsVideoMediaType(state, mediaObjectCardId),
  )
  const mediaThumbnail = useSelector((state: IApplicationState) =>
    selectThumbnailMediaUrl(state, mediaObjectCardId),
  )
  return (
    <CardContainer elementName="media-object-card">
      <Container relative>
        <ShareableContentLibraryTrackedRoute
          eventName={EventTrackingNames.ShareableCLViewContentLibraryItem}
          source="shareable_cl_discover"
          mediaObjectId={mediaObjectCardId}
        >
          <Link
            to={{
              pathname: `/${PageRoutes.ShareableContentLibrary}/${token}/${mediaObjectCardId}`,
            }}
          >
            <MediaThumbnail src={mediaThumbnail} aspectRatio={AspectRatios.ONE_BY_ONE} />
            {isVideoMediaType && <CardIcon opacity={0.5} icon={MediaTypes.VIDEO} />}
          </Link>
        </ShareableContentLibraryTrackedRoute>
      </Container>
    </CardContainer>
  )
}

export { ShareableContentLibraryCard }
export default ShareableContentLibraryCard
